import { useEffect, useState } from "react";
import Api from "../../utils/Api";
import {
  API_ROUTE_E_RETAIL_BUYERS_DATA,
  API_ROUTE_E_RETAIL_BUYERS_DATA_EXPORT,
  API_ROUTE_E_RETAIL_BUYERS_LOCKED_LINES,
} from "../../routes";
import { debug } from "../../utils/helpers";
import {
  DEFAULT_E_RETAIL_DATA_ASSIGNMENT_PAYLOAD,
  DEFAULT_E_RETAIL_DATA_ASSIGNMENT_EXPORT_PAYLOAD,
} from "../../constants";

export default function useBuyersData(auto = false) {
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [buyersData, setBuyersData] = useState([]);

  const getBuyersData = (payload = {}, showLoader = true) => {
    setIsLoading(showLoader);

    return Api.post(API_ROUTE_E_RETAIL_BUYERS_DATA, {
      ...DEFAULT_E_RETAIL_DATA_ASSIGNMENT_PAYLOAD,
      ...payload,
    })
      .then((response) => {
        setBuyersData(response.data);
      })
      .catch((error) => {
        debug.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const exportBuyersData = (payload = {}) => {
    setIsExporting(true);

    return Api.post(
      API_ROUTE_E_RETAIL_BUYERS_DATA_EXPORT,
      {
        ...DEFAULT_E_RETAIL_DATA_ASSIGNMENT_EXPORT_PAYLOAD,
        ...payload,
      },
      { responseType: "blob" },
    )
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch(async (error) => {
        debug.error(error);
        const err = JSON.parse(await error?.response?.data.text());
        return Promise.reject(err?.errors?.SearchFilter);
      })
      .finally(() => {
        setIsExporting(false);
      });
  };

  const lockBuyerLines = (payload, showLoader = false) => {
    setIsLoading(showLoader);

    return Api.patch(API_ROUTE_E_RETAIL_BUYERS_LOCKED_LINES, payload)
      .catch((error) => Promise.reject(error?.response?.data?.errors?.LineIds))
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!auto) {
      return;
    }
    getBuyersData();
  }, [auto]);

  return {
    isLoading,
    isExporting,
    buyersData,
    getBuyersData,
    exportBuyersData,
    setBuyersData,
    lockBuyerLines,
  };
}
